import EmailDeliveryView from "./EmailDeliveryView";

export default [
  {
    path: "/email_queue",
    name: "admin_email_delivery",
    component: EmailDeliveryView,
    meta: {
      tabAccess: "ADMIN",
    },
  },
];
